import { FaCanadianMapleLeaf } from "@react-icons/all-files/fa/FaCanadianMapleLeaf";
import React from "react";

import contactData from "../data/contact.yaml";
import * as styles from "../styles/Footer.module.css";
import EmailSignUp from "./EmailSignUp";

export interface FooterProps {}

const Footer = (_: FooterProps) => {
  return (
    <div className={styles.outer_container}>
      <EmailSignUp inputLabel={"Stay up to date"} subscribeBtnText={"Subscribe"} />
      <div className={styles.container}>
        <div>
          <p>
            <b>Products</b>
          </p>
          <a href={"/products/nexid"}>NexID Wristband</a>
          <a href={"/products/nexhub"}>NexHUB App</a>
        </div>
        <div>
          <p>
            <b>Policies</b>
          </p>
          <a href={"/policies/privacy"}>Privacy Policy</a>
          <a href={"/policies/tos"}>Terms of Service</a>
        </div>
        <div>
          <p>
            <b>Contact Us</b>
          </p>
          <a href={contactData.email.url}>info@nexushealth.ca</a>
        </div>
      </div>
      <div className={styles.copy}>
        <div>
          <b>Proudly made in Canada</b> <FaCanadianMapleLeaf />
        </div>
        &copy; {new Date().getFullYear()} Nexus Health
      </div>
    </div>
  );
};

export default Footer;
